import { createPortal } from 'react-dom';

function Portal({ children, targetId }) {
  return createPortal(children, document.getElementById(targetId));
}

export { Portal };
